<h2 class="title">{{ attributes.title }}</h2>
<p class="body">{{ attributes.body }}</p>
<div class="actions">
  <button class="btn btn-cancel close" [ngClass]="{'btn-delete': attributes.isErrorBtn}" (click)="confirmDialog.close(false)">{{ attributes.close }}</button>
  <button class="btn accept" [ngClass]="{'btn-warning': attributes.accept !== 'Save', 'btn-primary': attributes.accept == 'Save'}"
    *ngIf="attributes.accept" (click)="confirmDialog.close(true)">{{ attributes.accept }}</button>
</div>
